export default class TokenError extends Error {
  type

  status

  requestUrl

  constructor(message: string, type: string, status?: number, requestUrl?: string) {
    super(message)
    this.message = message || 'Error fetching new token data'
    this.name = 'TokenError'
    this.type = type || 'TOKEN_ERROR'
    this.status = status
    this.requestUrl = requestUrl

    Object.setPrototypeOf(this, TokenError.prototype)
  }
}
